/**
 * 要素の表示/非表示を hidden 属性で切り替える。
 * @param {HTMLElement | null} element
 * @param {boolean} visible
 */
export function toggleVisibility(element, visible) {
  if (!element) return;

  element.hidden = !visible;
}
